import { API } from 'common/constants/urls';
import { post } from 'common/axiosClient';
import { FixPayappHeadersDTO, FixPayappRowDTO, LineItemMatchDTO, MatchPayappLineItemsDTO } from './openai.type';

export const fixPayappHeaders = async (dto: FixPayappHeadersDTO) => {
  return await post(`${API.OPEN_AI}/fix-payapp-headers`, dto);
};
export const fixPayappRow = async (dto: FixPayappRowDTO) => {
  return await post(`${API.OPEN_AI}/fix-payapp-row`, dto);
};
export const matchPayappLineItems = async (dto: MatchPayappLineItemsDTO) => {
  return (await post(`${API.OPEN_AI}/match-payapp-line-items`, dto)) as LineItemMatchDTO[];
};
